import { render, staticRenderFns } from "./ComicsBook.vue?vue&type=template&id=5c035aad&scoped=true&"
import script from "./ComicsBook.vue?vue&type=script&lang=js&"
export * from "./ComicsBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c035aad",
  null
  
)

export default component.exports